import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ToastService } from '../../services/notification/toast.service';
import { WebService}  from '../../services/web/web.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import {PaymentPopupComponent} from "./payment-popup/payment-popup.component";
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SecurityService} from "../../services/security.service";
import {PlanType} from "../../shared/enums/plan-type";
import { ServiceType } from '../../shared/enums/service-type';
import { shouldShowPaymentButton } from '../../shared/utils/onboarding-payment-status';
import {SessionStoreService} from '../../services/session-store.service';
@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.scss'],
    standalone: false
})
export class PlansComponent implements OnInit, OnDestroy {

  plans : any = [];

  readonly PlanType = PlanType;

  form: FormGroup ;

  isVariable: boolean = false;
  isOnDemand: boolean = false;
  private savedFieldValues: {[key: string]: any} = {};

  isSubmitting: boolean = false;

  private destroy$ = new Subject<void>();

  @ViewChild('inputFile') myInputVariable: ElementRef | undefined;


  frecuencies : any;
  frecuencyName: string = 'Mensuales';
  imageName = null;
	image64: any;
	imageType: any;
  onboardingConfigID: any;
  showPaymentButton : Boolean = false;
  goToMyPortals : Boolean = false;

  constructor(private securityService : SecurityService,
              private dialog: MatDialog,
              private activateRoute : ActivatedRoute,
              private router : Router,
              private toast : ToastService,
              private spinner : SpinnerService,
              private webService : WebService,
              private sessionStore: SessionStoreService ) {
    this.plans.push(1);

    this.form = new FormGroup({
     // id: new FormControl(''),
      name_plan: new FormControl('', Validators.required),
      feeCost_plan: new FormControl('', Validators.required),
      freezeCostPlan : new FormControl('', Validators.required),
      enrollmentCost_plan: new FormControl(0),
      frecuency : new FormControl('', Validators.required),
      status_plan : new FormControl(1, Validators.required),
      taxRate_plan : new FormControl('', Validators.required),
      service: new FormControl(''),
      description : new FormControl('', Validators.required),
      idPlan_partner : new FormControl("123", Validators.required),
      cobro_by_partner : new FormControl(false, Validators.required),
      verify_invoices_on_partner : new FormControl(false, Validators.required),
      charge_inmediately : new FormControl(false, Validators.required),
      qty_installments_to_collect_plan: new FormControl(''),
      is_visible_plan: new FormControl(true, Validators.required),
      type: new FormControl(PlanType.NORMAL, Validators.required)
    });

  }

  ngOnInit(): void {
      this.form.controls['type'].valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe((type) => this.onTypeChange(+type));

      this.spinner.open();

      this.webService.get(this.webService.HOST + "/frecuency").subscribe( response =>{
        this.frecuencies = response.result;
        this.activateRoute.queryParams.subscribe(queryParams =>{
          if(queryParams['config']){
            // Caso 1: Config viene por queryParams (preferido)
            this.onboardingConfigID = +queryParams['config'];
            this.habilitatePaymentButton();
            this.getConfigByID();
          }else{
            // Caso 2: Intentar obtener de la sesión de portal
            const usesPortalSession = this.securityService.isOnboardingAdmin() ||
              this.securityService.isSuperAdmin();
            const session = usesPortalSession
              ? this.sessionStore.getSesion()
              : null;
            if(session?.config && session.config.length > 0){
              // Tomar el primer config del array
              this.onboardingConfigID = +session.config[0];
              this.habilitatePaymentButton();
              this.getConfigByID();
              return; // Salir para evitar ejecutar el resto
            }
            
            // Caso 3: Intentar obtener del token JWT
            if(this.securityService.getTokenConfigs() !=  null){
              if(this.securityService.getTokenConfigs().length === 1){
                this.onboardingConfigID = +this.securityService.getTokenConfigs()[0];
                this.habilitatePaymentButton();
                this.getConfigByID();
              } else {
                // No hay configuración única disponible
                this.spinner.close();
              }
            } else {
              // No hay configuraciones disponibles
              this.spinner.close();
            }
          }
        }, err =>{
          this.spinner.close();
          this.toast.showError(err);
        });
      }, err =>{
        this.spinner.close();
        this.toast.showError(err);
      });


  }

  habilitatePaymentButton(){

    let partner = -1;

    if(this.securityService.getTokenPartner() != null || this.securityService.getTokenPartner() != undefined){
      partner = this.securityService.getTokenPartner()
    }

    this.webService.get(this.webService.HOST + "/onboardingConfig/" + this.onboardingConfigID + "?partner=" + partner).subscribe( response =>{
      const service = response.result.service;
      this.showPaymentButton = shouldShowPaymentButton(response);
      this.goToMyPortals = service.type === ServiceType.ONBOARDING ||
        service.current_onboarding_step == 5 ||
        service.current_onboarding_step == 6;

    }, err =>{
      this.toast.showError(err);
      this.spinner.close();
    });
  }

  getConfigByID(){
    let partner = -1;
    if(this.securityService.getTokenPartner() != null || this.securityService.getTokenPartner() != undefined){
      partner = this.securityService.getTokenPartner()
    }

    this.webService.get(this.webService.HOST + "/onboardingConfig/" + this.onboardingConfigID + "?partner=" + partner).subscribe( config =>{
      this.spinner.close();
      this.form.controls["service"].setValue({id:config.result.service.id});
    }, err =>{
      this.spinner.close();
      this.toast.showError(err);
    });
  }

  myportals(){
    this.toast.showInfo("Funcionalidad en desarrollo, debe mostrar pantalla con portales")
  }

  send(){

    if (this.isSubmitting) {
      return;
    }

    if(!this.form.valid){
      this.form.markAllAsTouched();
      return this.toast.showError("Porfavor, complete el formulario...");
    }

    // getRawValue incluye controles disabled (necesario para ON_DEMAND)
    const payload = this.form.getRawValue();
    payload.frecuency = payload.frecuency ? { id: +payload.frecuency } : null;
    payload.image64 = this.image64;
    payload.imageName = this.imageName;
    payload.imageType = this.imageType;
    payload.onboarding_config = { id: +this.onboardingConfigID };
    payload.qty_installments_to_collect_plan = +payload.qty_installments_to_collect_plan;
    payload.is_visible_plan = payload.is_visible_plan === 'true' || payload.is_visible_plan === true;
    payload.type = +payload.type;

    this.isSubmitting = true;
    this.spinner.open();

    this.webService.post({plan: payload, onboarding: true, onboardingId: +this.onboardingConfigID}, this.webService.HOST + "/plan").subscribe(response =>{

      this.isSubmitting = false;
      this.spinner.close();
      this.toast.showSuccess("Plan creado correctamente...");
      this.router.navigate(["/edit/portal/"+this.onboardingConfigID+"/my-plans"], {relativeTo : this.activateRoute, queryParamsHandling : "preserve"});

    }, err =>{
      this.isSubmitting = false;
      this.spinner.close();
      this.toast.showError(err);
    });


  }

  resetFormVariables() {
    // Resetear las variables del formulario
    this.imageName = null;
    this.image64 = null;
    this.imageType = null;
    // Agrega cualquier otra variable que necesites restablecer aquí

    // Resetear los valores del FormGroup a sus valores originales o valores por defecto
    this.form.reset({
      name_plan: '',
      feeCost_plan: '',
      freezeCostPlan: '',
      enrollmentCost_plan: 0,
      frecuency: '',
      status_plan: 1,
      taxRate_plan: '',
      service: '',
      description: '',
      idPlan_partner: '123',
      cobro_by_partner: false,
      verify_invoices_on_partner: false,
      charge_inmediately: false,
      frecuencyName:'Mensuales'
    });
  }

  onLogoChange(event : any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
      this.imageName = file.name;
      this.imageType = file.type;
      this.image64 = reader.result!.toString();
      };
    }
  }

  goBack(){
    if(this.onboardingConfigID){
      this.router.navigate(["/edit/portal/" + this.onboardingConfigID]);
    } else {
      this.router.navigate(["/settings"]);
    }
  }

  goToPortals(){
    this.router.navigate(["/my-portals"], {relativeTo : this.activateRoute, queryParamsHandling : "preserve"});
  }

  // PENDIENTE
  processPayment(){
    let dialogRef: MatDialogRef<any> = this.dialog.open(PaymentPopupComponent, {
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      disableClose: true,
      data: {  configID : this.onboardingConfigID }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if(res != undefined &&  res == 1){// SOLO SI ES COBRADO
          this.router.navigateByUrl("/congratulation");
        }
        // else{
        //   window.location.reload();
        // }
      })
  }

  onChangeFrecuency(index: number) {
    index = index - 1;  // restamos 1 al índice
    this.frecuencyName = this.frecuencies[index].name_frecuency;
  }

  handleCreatePlanClick() {
    this.router.navigateByUrl('/plans');
  }
  
  goToTemplates(){
    this.router.navigate(["/portal"], {relativeTo : this.activateRoute, queryParamsHandling : "preserve"});
  

  }

 
  goToAccount(){
    this.router.navigate(["/settings"], {relativeTo : this.activateRoute, queryParamsHandling : "preserve"});
  }

  private onTypeChange(type: number): void {
    if (type === PlanType.VARIABLE) {
      this.isVariable = true;
      this.isOnDemand = false;
      this.applyVariableDefaults();
    } else if (type === PlanType.ON_DEMAND) {
      this.isVariable = false;
      this.isOnDemand = true;
      this.saveFieldValues();
      this.applyOnDemandDefaults();
    } else {
      this.isVariable = false;
      this.isOnDemand = false;
      this.restoreNonVariableValidators();
    }
  }

  private applyVariableDefaults(): void {
    const hiddenControls = ['feeCost_plan', 'taxRate_plan', 'freezeCostPlan', 'is_visible_plan'];
    hiddenControls.forEach((name) => {
      const control = this.form.controls[name];
      control.enable({ emitEvent: false });
      control.clearValidators();
      control.updateValueAndValidity({ emitEvent: false });
    });

    const frecuencyControl = this.form.controls['frecuency'];
    frecuencyControl.enable({ emitEvent: false });
    frecuencyControl.setValidators([Validators.required]);
    frecuencyControl.updateValueAndValidity({ emitEvent: false });

    this.form.controls['enrollmentCost_plan'].enable({ emitEvent: false });
    this.form.controls['feeCost_plan'].setValue(0, { emitEvent: false });
    this.form.controls['taxRate_plan'].setValue(0, { emitEvent: false });
    this.form.controls['freezeCostPlan'].setValue(0, { emitEvent: false });
    this.form.controls['is_visible_plan'].setValue(false, { emitEvent: false });
    this.form.controls['qty_installments_to_collect_plan'].setValue('', { emitEvent: false });

    this.imageName = null;
    this.image64 = null;
    this.imageType = null;
    if (this.myInputVariable) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  private saveFieldValues(): void {
    const fields = ['feeCost_plan', 'taxRate_plan', 'freezeCostPlan', 'enrollmentCost_plan', 'is_visible_plan', 'frecuency'];
    fields.forEach(name => {
      this.savedFieldValues[name] = this.form.controls[name].value;
    });
  }

  private applyOnDemandDefaults(): void {
    const fixedControls = ['feeCost_plan', 'taxRate_plan', 'freezeCostPlan', 'enrollmentCost_plan', 'is_visible_plan', 'frecuency'];
    fixedControls.forEach(name => {
      const control = this.form.controls[name];
      control.clearValidators();
      control.updateValueAndValidity({ emitEvent: false });
    });
    this.form.controls['feeCost_plan'].setValue(0.01, { emitEvent: false });
    this.form.controls['taxRate_plan'].setValue(0.01, { emitEvent: false });
    this.form.controls['freezeCostPlan'].setValue(0.01, { emitEvent: false });
    this.form.controls['enrollmentCost_plan'].setValue(0.01, { emitEvent: false });
    this.form.controls['is_visible_plan'].setValue(false, { emitEvent: false });
    // Enviar primera frecuencia disponible — backend ON_DEMAND la sobrescribe con la del config
    const defaultFrecId = this.frecuencies && this.frecuencies.length > 0 ? this.frecuencies[0].id : '';
    this.form.controls['frecuency'].setValue(defaultFrecId, { emitEvent: false });
    fixedControls.forEach(name => this.form.controls[name].disable({ emitEvent: false }));
    this.form.controls['qty_installments_to_collect_plan'].setValue('', { emitEvent: false });
    this.imageName = null;
    this.image64 = null;
    this.imageType = null;
    if (this.myInputVariable) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  private restoreNonVariableValidators(): void {
    const requiredControls = ['feeCost_plan', 'taxRate_plan', 'freezeCostPlan', 'is_visible_plan', 'frecuency'];
    requiredControls.forEach((name) => {
      const control = this.form.controls[name];
      control.enable({ emitEvent: false });
      const saved = this.savedFieldValues[name];
      const hasValid = saved !== undefined && saved !== null && saved !== '' && saved !== 0.01 && saved !== false;
      control.setValue(hasValid ? saved : '', { emitEvent: false });
      control.setValidators([Validators.required]);
      control.updateValueAndValidity({ emitEvent: false });
    });
    this.form.controls['enrollmentCost_plan'].enable({ emitEvent: false });
    const savedEnroll = this.savedFieldValues['enrollmentCost_plan'];
    const hasValidEnroll = savedEnroll !== undefined && savedEnroll !== null && savedEnroll !== '' && savedEnroll !== 0.01;
    this.form.controls['enrollmentCost_plan'].setValue(hasValidEnroll ? savedEnroll : 0, { emitEvent: false });
    this.savedFieldValues = {};
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
